import React from 'react';

import { CONTENT_HISTORY } from '@confluence/named-routes';

export const getPageHistoryLink = (attributes) => {
	const { spaceKey, contentId, contentSlug } = attributes;
	return (...chunks) => (
		<a
			target="_blank"
			href={CONTENT_HISTORY.toUrl({
				spaceKey,
				contentId,
				contentSlug,
			})}
		>
			{chunks}
		</a>
	);
};
